jQuery(document).ready(function() {
	// load slider for Headslider

	
jQuery('.galleriewrap').slick({
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 14000 
}); 

jQuery('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 479"><style type="text/css">.st0{fill:#FFFFFF;}</style><g transform="translate(1759 1724)rotate(180)"><rect x="1259.5" y="1245" width="499.4" height="479"/><path class="st0" d="M1452.2 1327l-37 37 121.4 121.4L1415.2 1606.8l37 37 158.4-158.4L1452.2 1327z"/></g></svg>').appendTo( ".slick-next ,.slick-prev");	

});

